const formInputField = document.querySelectorAll(".initial-state");
const form = document.querySelectorAll(".form");

formInputField.forEach(function (e) {
  e.addEventListener("blur", function () {
      this.classList.remove("initial-state");
  });

  // for Radio Buttons
  e.addEventListener("change", function () {
    const groupName =  this.name;
    if(groupName) {
      const group = document.querySelectorAll(`[name="${groupName}"]`);
      group.forEach(function (e) {
        e.classList.remove("initial-state");
      })
    }
  });
});

form.forEach(function(cForm) {
  const submit = cForm.querySelector('button[type="submit"]');
  submit.addEventListener('click', function() {
    cForm.querySelectorAll(".initial-state").forEach(function(input) {
      input.classList.remove("initial-state");
    })
  })
})

if (
  document.getElementById('kontaktformularmitAnliegen-3169-singleselect-1') != null
  && document.getElementById('kontaktformularmitAnliegen-3169-singleselect-1').length > 0
  && document.querySelectorAll('[for="kontaktformularmitAnliegen-3169-checkbox-1"]') != null
  && document.querySelectorAll('[for="kontaktformularmitAnliegen-3169-checkbox-1"]').length > 0
) {
  let subject = document.getElementById('kontaktformularmitAnliegen-3169-singleselect-1');
  let checkbox = document.querySelectorAll('[for="kontaktformularmitAnliegen-3169-checkbox-1"]');
  checkbox.forEach(function(e){ e.style.display = 'none'; });
  subject.addEventListener('change', function() {
    checkbox.forEach(function(e){
      if (subject.value === 'Produktberatung') {
        e.style.display = 'block';
      }
      else {
        e.style.display = 'none';
      }
    });
  } );
}
